import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { handleResponse } from 'APIPackage/MainModule/common/handleResponse';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiMockSwitcher } from 'APIPackage/MainModule/mock/apiMockSwitcher';

import { IInteractionCategory } from '../interfaces/IInteractionCategory';

export async function fetchInteractionCategories(): Promise<IInteractionCategory[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/interaction-category`;
  const mockData = apiMockSwitcher<IInteractionCategory[]>(url, 'GET');

  if (mockData) return mockData;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}
